
import _ from 'lodash';
export default {
  created: function created() {
    this.getBreadcrumb();
  },
  data: function data() {
    return {
      levelList: null
    };
  },

  watch: {
    $route: function $route() {
      this.getBreadcrumb();
    }
  },
  methods: {
    getBreadcrumb: function getBreadcrumb() {
      var matched = this.$route.matched.filter(function (item) {
        return item.name;
      }).map(function (item) {
        return {
          meta: _.cloneDeep(item.meta),
          path: item.path
        };
      });
      if (this.$route.name === 'creative.common-template') {
        matched[0].meta.title = '试玩模板管理';
      }
      this.levelList = matched;
      // if (this.$route.name === '编辑素材' && this.$route.query.creative_id) {
      //   this.id = this.$route.query.creative_id;
      // } else if (this.$route.name === '编辑' && this.$route.params.id) {
      //   this.id = this.$route.params.id;
      // } else {
      //   this.id = ''
      // }
    }
  }
};